import { PayloadAction } from '@reduxjs/toolkit';
export function resetState(newState: unknown): ResetStateAction {
  return {
    type: resetStateActionType,
    payload: newState
  };
}
export const resetStateActionType = 'resetState' as const;
export type ResetStateAction = PayloadAction<unknown, typeof resetStateActionType>;